import { render, staticRenderFns } from "./ConfirmKitUnArchive.vue?vue&type=template&id=0cc7bba1&scoped=true&"
import script from "./ConfirmKitUnArchive.vue?vue&type=script&lang=js&"
export * from "./ConfirmKitUnArchive.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmKitUnArchive.vue?vue&type=style&index=0&id=0cc7bba1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc7bba1",
  null
  
)

export default component.exports